/* Yummy Combs Dog Match Quiz · Option C "Name-first chat" UI.
 Needs ycq-engine.js (window.YCQ). Every string comes from the ycq-chat-quiz
 section settings (window.YCQ_LIVE.t). Tokens: {dog} {Dog} {greet} {name}
 {first} {size} {count} {price} {product}. Token values are escaped; setting
 text is merchant-authored and may hold simple HTML. */
(function () {
 function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
 function fmt(str, map) { return String(str || "").replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; }); }
 function pipe(s, n, fb) { var a = String(s || "").split("|").map(function (x) { return x.trim(); }); return a.length === n && a.every(Boolean) ? a : fb; }

 function init(root, T) {
 var E = window.YCQ, S, thread;
 if (!E || !root || root.getAttribute("data-ycq-ready")) return;
 root.setAttribute("data-ycq-ready", "1");
 function $(sel) { return root.querySelector(sel); }
 function dog() { return S.dog ? esc(S.dog) : esc(T.dogFallback); }
 function Dog() { return S.dog ? esc(S.dog) : esc(T.DogFallback); }
 function tok(extra) {
 var m = { dog: dog(), Dog: Dog(), name: esc(S.dog), greet: S.dog ? "<b>" + esc(S.dog) + "</b>" : esc(T.greetFallback) };
 for (var k in extra) m[k] = extra[k];
 return m;
 }
 // answer labels are editable, values are fixed because scoring keys off them
 ["age", "protein", "plan"].forEach(function (k) {
 var q = E.Q[k], labels = pipe(T[k + "Labels"], q.options.length, null);
 if (labels) q.options.forEach(function (o, i) { o.label = labels[i]; });
 });
 E.Q.plan.options.forEach(function (o) { if (o.v === "daily") o.badge = T.planBadge || ""; });

 var ASK = {
 weight: function () { return fmt(T.qWeight, tok()); },
 age: function () { return fmt(T.qAge, tok()); },
 protein: function () { return fmt(T.qProtein, tok()); },
 plan: function () { return fmt(T.qPlan, tok()); }
 };

 function opener() {
 S = { dog: "", a: {}, i: 0, sub: null, res: null };
 root.innerHTML = '<section class="ycc-open">' +
 '<h1>' + T.headingBefore + ' <em>' + T.headingEm + '</em></h1>' +
 (T.sub ? '<p>' + T.sub + '</p>' : '') +
 '<form class="ycc-name" data-ycq-name><input data-ycq-dog placeholder="' + esc(T.namePh) + '" maxlength="24" autocomplete="off" aria-label="' + esc(T.namePh) + '"><button class="ycc-btn" type="submit">' + esc(T.start) + '</button></form>' +
 (T.skip ? '<button class="ycc-skip" type="button" data-ycq-skip>' + esc(T.skip) + '</button>' : '') +
 (T.trust && T.trust.length ? '<div class="ycc-trust">' + T.trust.map(function (t) { return '<span>' + t + '</span>'; }).join("") + '</div>' : '') +
 '</section>';
 $("[data-ycq-name]").onsubmit = function (e) { e.preventDefault(); start($("[data-ycq-dog]").value.trim()); };
 var sk = $("[data-ycq-skip]"); if (sk) sk.onclick = function () { start(""); };
 }

 function start(name) {
 S.dog = name.replace(/[<>]/g, "").slice(0, 24); E.track("QuizStarted", { has_dog_name: !!S.dog });
 root.innerHTML = '<div class="ycc-thread"></div>'; thread = $(".ycc-thread");
 if (S.dog) me(S.dog);
 bot(ASK.weight(), function () { answers("weight"); });
 }

 function bot(html, then) {
 var t = document.createElement("div"); t.className = "ycc-typing"; t.innerHTML = "<span></span><span></span><span></span>";
 var w = document.createElement("p"); w.className = "ycc-who"; w.innerHTML = "<i></i>" + esc(T.botName);
 thread.appendChild(w); thread.appendChild(t); scroll();
 setTimeout(function () { t.outerHTML = '<div class="ycc-msg ycc-msg--bot">' + html + '</div>'; scroll(); then && then(); }, 520);
 }
 function me(text) { var m = document.createElement("div"); m.className = "ycc-msg ycc-msg--me"; m.textContent = text; thread.appendChild(m); scroll(); }
 function scroll() { var l = thread.lastElementChild; if (l) l.scrollIntoView({ behavior: "smooth", block: "end" }); }

 function answers(k) {
 var q = E.Q[k], box = document.createElement("div"); box.className = "ycc-answers"; box.setAttribute("role", "group");
 q.options.forEach(function (o) {
 var b = document.createElement("button"); b.className = "ycc-ans"; b.type = "button";
 b.innerHTML = (k === "weight" ? '<img src="' + E.img("c12", o.v, 120) + '" alt="">' : '') + esc(k === "weight" ? E.SIZES[o.v].label + " · " + o.label : o.label) + (o.badge ? '<span class="ycc-badge">' + esc(o.badge) + '</span>' : '');
 b.onclick = function () { box.remove(); choose(k, o); }; box.appendChild(b);
 });
 thread.appendChild(box); scroll();
 }

 function choose(k, o) {
 S.a[k] = o.v; me(k === "weight" ? E.SIZES[o.v].label + ", " + o.label : o.label);
 E.track("QuizStepCompleted", { question: k, answer: String(o.v) });
 if (k === "age" && o.v === "pup") { bot(fmt(T.puppyMsg, tok()), function () { mail(true); }); return; }
 if (k === "age" && o.v === "senior") return bot(fmt(T.seniorMsg, tok()), next);
 if (k === "protein" && o.v === "no") return bot(fmt(T.noChickenMsg, tok()), next);
 next();
 }
 function next() {
 var i = E.ORDER.indexOf(Object.keys(S.a).slice(-1)[0]) + 1;
 if (i < E.ORDER.length) { var k = E.ORDER[i]; bot(ASK[k](), function () { answers(k); }); }
 else { S.res = E.compute(S.a); bot(fmt(T.readyMsg, tok()), function () { mail(false); }); }
 }

 function mail(puppy) {
 var f = document.createElement("form"); f.className = "ycc-mail"; f.noValidate = true;
 var label = puppy ? T.remindBtn : (S.dog ? fmt(T.showBtn, tok()) : T.showBtnNoName);
 f.innerHTML = '<input data-ycq-first placeholder="' + esc(T.firstPh) + '" autocomplete="given-name" aria-label="' + esc(T.firstPh) + '"><input data-ycq-email type="email" placeholder="' + esc(T.emailPh) + '" autocomplete="email" aria-label="' + esc(T.emailPh) + '"><button class="ycc-btn" type="submit">' + label + '</button><p class="ycc-err" role="alert"></p>' + (T.consent ? '<small>' + T.consent + '</small>' : '') + (E.preview() && T.designMode ? '<p class="ycc-preview">' + T.previewNote + '</p>' : '');
 f.onsubmit = function (e) {
 e.preventDefault();
 var n = f.querySelector("[data-ycq-first]").value.trim(), em = f.querySelector("[data-ycq-email]").value.trim(), er = f.querySelector(".ycc-err");
 if (!n) { er.textContent = T.errName; return; }
 if (!E.validEmail(em)) { er.textContent = T.errEmail; return; }
 f.querySelector("button").disabled = true;
 var res = puppy ? { puppy: true } : S.res;
 E.subscribe({ email: em, firstName: n, result: puppy ? null : E.P[res.primary].title, props: E.profileProps(S.a, res, S.dog) }).then(function () {
 f.remove(); me(em);
 if (puppy) bot(fmt(T.thanksPuppy, tok({ first: esc(n) })), function () { again(); });
 else bot(fmt(T.thanksPlan, tok({ first: esc(n) })), sheet);
 });
 };
 thread.appendChild(f); scroll(); setTimeout(function () { f.querySelector("[data-ycq-first]").focus({ preventScroll: true }); }, 50);
 }

 function sheet() {
 var r = S.res, p = E.P[r.primary], sz = E.SIZES[r.size], k = r.primary;
 if (S.sub === null) S.sub = r.sub;
 var hasSub = !!p.sub, sub = hasSub && S.sub, price = E.priceOf(k, r.size, sub), pt = E.perTreat(k, r.size, sub);
 E.track("QuizResultViewed", { recommended_product: p.title, size: sz.label });
 var old = $(".ycc-sheet"); if (old) old.remove();
 var el = document.createElement("section"); el.className = "ycc-sheet";
 var t = tok({ size: esc(sz.label), count: p.count });
 var routine = '<div><b>' + esc(T.rowDaily) + '</b><span>' + fmt(T.rowDailyText, t) + '</span></div>' +
 (r.secondary === "l15" ? '<div><b>' + esc(T.rowDinner) + '</b><span>' + fmt(T.rowDinnerText, t) + '</span></div>' : '') +
 '<div><b>' + esc(T.rowRestock) + '</b><span>' + (p.count ? fmt(T.restockBag, t) : fmt(T.restockMini, t)) + (hasSub ? ' ' + fmt(T.restockSub, t) : '') + '</span></div>';
 var cta = fmt(S.dog ? T.ctaName : T.ctaNoName, tok({ product: esc(p.name) }));
 el.innerHTML = '<div class="ycc-sheet__head"><p>' + esc(T.sheetEyebrow) + '</p><h2>' + fmt(S.dog ? T.sheetHeading : T.sheetHeadingNoName, tok()) + '</h2></div>' +
 '<div class="ycc-sheet__body"><div class="ycc-prod"><img src="' + E.img(k, r.size, 400) + '" alt="' + esc(p.title) + '"><div><h3>' + esc(p.name) + ' · ' + esc(p.flavor) + '</h3><p>' + esc(sz.label) + ' (' + esc(sz.short) + ')' + (p.count ? ' · ' + p.count + ' treats' : '') + '</p></div></div>' +
 '<div class="ycc-day">' + routine + '</div>' +
 '<ul class="ycc-why">' + r.reasons.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join("") + '</ul>' +
 '<div class="ycc-buy">' + (hasSub ? '<div class="ycc-freq"><button type="button" data-s="0" aria-pressed="' + !sub + '">' + fmt(T.freqOnce, { price: E.money(p.price[r.size]) }) + '</button><button type="button" data-s="1" aria-pressed="' + sub + '">' + T.freqSub + '</button></div>' : '') +
 '<div class="ycc-price"><strong>' + (sub ? '<s>' + E.money(p.price[r.size]) + '</s>' : '') + E.money(price) + '</strong>' + (pt ? '<span>' + fmt(T.perTreat, { price: pt }) + '</span>' : '') + '</div>' +
 '<a class="ycc-btn" href="' + E.variantUrl(k, r.size, sub) + '" data-cta="' + k + '">' + cta + '</a>' +
 (r.secondary === "l15" ? '<a class="ycc-btn ycc-btn--ghost" href="' + E.variantUrl("l15", r.size, false) + '" data-cta2="l15">' + fmt(T.addL15, { price: E.money(E.P.l15.price[r.size]) }) + '</a>' : '') +
 (r.secondary && r.secondary !== "l15" ? '<p class="ycc-or">' + fmt(T.orTry, { product: '<a href="' + E.variantUrl(r.secondary, r.size, false) + '" data-cta2="' + r.secondary + '">' + esc(E.P[r.secondary].title) + '</a>', price: E.money(E.P[r.secondary].price[r.size]) }) + '</p>' : '') +
 '</div>' + (T.foot ? '<p class="ycc-foot">' + T.foot + '</p>' : '') + '</div>';
 thread.appendChild(el);
 el.querySelectorAll("[data-s]").forEach(function (b) { b.onclick = function () { S.sub = b.getAttribute("data-s") === "1"; sheet(); }; });
 el.querySelectorAll("[data-cta],[data-cta2]").forEach(function (a) { a.onclick = function () { var kk = a.getAttribute("data-cta") || a.getAttribute("data-cta2"); E.track("QuizProductClick", { product: E.P[kk].title, slot: a.getAttribute("data-cta") ? "primary" : "secondary" }); }; });
 var ag = $(".ycc-again"); if (!ag) again(); else thread.appendChild(ag);
 if (!sheet.shown) { sheet.shown = 1; el.scrollIntoView({ behavior: "smooth", block: "start" }); }
 }
 function again() { var b = document.createElement("button"); b.type = "button"; b.className = "ycc-again"; b.textContent = T.again; b.onclick = function () { sheet.shown = 0; opener(); }; thread.appendChild(b); }

 opener();
 }

 window.YCQChat = { init: init };
 function boot() { document.querySelectorAll("[data-ycq-root]").forEach(function (el) { var c = window.YCQ_LIVE; if (c && c.t) init(el, c.t); }); }
 if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
 // theme editor: re-run when the section reloads
 document.addEventListener("shopify:section:load", boot);
})();
